<template>
  <div class="about-container pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3">
    <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
      <v-col xl="8" lg="9" md="10" sm="11" cols="11" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="text-left headline font-weight-bold section-title mt-1 mb-4">
          ¿Quiénes somos?
        </div>
      </v-col>
      <v-col xl="8" lg="9" md="10" sm="12" cols="12">
        <v-card class="mx-auto text-left pt-3 pb-7" tile :flat="$vuetify.breakpoint.smAndDown">
          <div class="text-center title font-weight-bold section-title mt-2" v-if="$vuetify.breakpoint.smAndDown">
            ¿Quiénes somos?
          </div>
          <v-row justify="center" class="pt-xl-4 pt-lg-2 pt-md-4 pt-sm-0 pt-0" no-gutters>
            <v-col xl="11" lg="11" md="11" sm="11" cols="11">
              <v-row justify="center">
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    ¿Qué es {{ appName }}?
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="font-weight-medium text--primary">{{ appName }}.com </span>
                    <span class="text--primary">
                      es la primera óptica en línea de Colombia. Donde encontraras productos de diferentes
                      marcas con los mejores estandares de calidad, además de disfrutar de una experiencia
                      de compra única, ofreciendo diferentes metodos de pago tales como pse, tarjeta de credito,
                      efecty, baloto etc.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="font-weight-medium text--primary">{{ appName }}.com </span>
                    <span class="text--primary">
                      le ofrece los mejores precios con entregas rápidas a todo el pais, con devoluciones
                      sin costo teniendo en cuenta nuestra
                      <a class="blue--text text--darken-3" @click="goToRouteByName('Privacy-policies')">
                        políticas de cambios y devoluciones
                      </a>
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    ¿Dónde Estamos?
                  </div>
                  <div class="body-2">
                    <span class="text--primary font-weight-light">
                      Estamos ubicados en la {{ ubication.direction }}, {{ ubication.additional }}, {{ ubication.city }} {{ ubication.departament }}, {{ ubication.country }}.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Contáctanos
                  </div>
                  <div class="body-2">
                    <span class="text--primary font-weight-light">
                      Centro de atención al cliente en Cali (1) {{ phone.cell_phone }} (2) {{ phone.landline }} o
                      envíanos un e-mail a {{ email }}.
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import navigationMixin from '@/mixins/navigation'
import { UBICATION, PHONE, APP_NAME, EMAIL, NIT } from '@/config/local-info'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      appName: APP_NAME,
      ubication: UBICATION,
      phone: PHONE,
      email: EMAIL,
      nit: NIT
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .text-muted {
    line-height: 1.75em;
  }

  .about-container{
    height: 100%;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .about-container{
      background-color: #FFFFFF;
    }
  }
</style>
